// extracted by mini-css-extract-plugin
export default {"card-container":"FeedCard_card-container__BCs1F","card-division-line":"FeedCard_card-division-line__A1RD9","card-head-container":"FeedCard_card-head-container__l+ds3"};